import {
  createComponentPreviewMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  StylableHorizontalMenuProps,
  StylableHorizontalMenuCSSVars,
  StylableHorizontalMenuDefinition,
  StylableHorizontalMenuPropsCarmiData,
} from '../StylableHorizontalMenu.types';
import { getMinSize } from './utils/getMinSize';
import {
  props as viewerPropsMapper,
  css as viewerCssMapper,
} from './StylableHorizontalMenu.mapper';

const props = composeMapper<
  PreviewWrapperProps<StylableHorizontalMenuProps>,
  StylableHorizontalMenuDefinition,
  StylableHorizontalMenuPropsCarmiData
>()(
  viewerPropsMapper,
  { add: ['compPreviewState', 'compLayout'] },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    // TODO: should be reworked (compPreviewState should be string)
    const compPreviewState = (dependencies.compPreviewState as any)?.state;

    const width =
      viewerProps.menuMode === 'scroll'
        ? dependencies.compLayout.width
        : undefined;

    return {
      ...viewerProps,
      width,
      previewWrapperProps: {
        compPreviewState,
        compLayout: dependencies.compLayout,
      },
    };
  },
);

const css = composeMapper<
  PreviewWrapperProps<StylableHorizontalMenuCSSVars>,
  StylableHorizontalMenuDefinition
>()(viewerCssMapper, {}, (resolver, dependencies, carmiData) => {
  const viewerCss = resolver(dependencies, carmiData);
  const cssText = dependencies.styleProperties['st-css'];
  const { menuMode } = dependencies.compProps;

  return {
    ...viewerCss,
    ...getMinSize(menuMode, cssText),
  };
});

const uiType = withCompInfo()([], (() => 'Default') as any);

export default createComponentPreviewMapperModel({
  props,
  css,
  uiType,
} as any);
